import styled from "styled-components";
import m, { desktop } from "../../../styles/molanturTheme";
import { Card, Icon, Label } from "../ui";

// Liquidaciones: la sección existe en el menú pero todavía no tiene contenido. Acá van a aparecer
// los pagos del aliado y a qué pasajeros aplica cada uno.
export default function Settlements() {
    return (
        <Main>
            <Label>Pagos</Label>
            <h1>Liquidaciones</h1>
            <Card className="empty">
                <span className="icon"><Icon name="wallet" size={30} stroke={1.7} /></span>
                <strong>Todavía no hay liquidaciones para mostrar</strong>
                <p>Pronto verás aquí tus pagos a Molantur y a qué pasajeros corresponde cada uno.</p>
            </Card>
        </Main>
    )
}

const Main = styled.div`
    h1 {
        margin: 4px 0 18px;
        font-family: ${m.font.display};
        font-weight: 600;
        font-size: 26px;
        line-height: 1.1;
        color: ${m.color.ink};
    }
    .empty {
        padding: 40px 20px;
        text-align: center;
        strong {
            display: block;
            margin-top: 10px;
            font-weight: 600;
        }
        p {
            margin: 4px auto 0;
            max-width: 360px;
            font-size: 13px;
            line-height: 1.45;
            color: ${m.color.inkFaint};
        }
    }
    .icon {
        display: flex;
        justify-content: center;
        color: ${m.color.inkFaint};
    }
    ${desktop} {
        h1 { font-size: 38px; }
    }
`
